<template>
  <el-dialog title="创建动态表单 - 设置表" :visible.sync="show" append-to-body>
    <div style="text-align:center;">
      <el-radio-group v-model="mode" @change="loadMetadata" size="mini">
        <el-radio-button label="1">自动新建表</el-radio-button>
        <el-radio-button label="2">手动关联表</el-radio-button>
        <el-radio-button label="3">无表</el-radio-button>
      </el-radio-group>
    </div>
    <el-form size="mini">
      <template v-if="mode === '1'">
        <el-form-item label="ID列名">
          <el-input v-model="idColumnName1" placeholder="请填写ID列的名称"></el-input>
        </el-form-item>
        <el-form-item label="账户列名">
          <el-input v-model="accountColumnName1" placeholder="请填写普通账户列的名称，如果为空，代表该表的数据跟用户无从属关系"></el-input>
        </el-form-item>
        <el-form-item label="创建时间列名">
          <el-input v-model="createTimeColumnName1" placeholder="请填写数据创建时间列名，系统将创建该属性，当创建数据时自动填充值。如果为空，则代表不需要该属性"></el-input>
        </el-form-item>
        <el-form-item label="创建者列名">
          <el-input v-model="creatorColumnName1" placeholder="请填写数据创建者列名，系统将创建该属性，当创建数据时自动填充值。如果为空，则代表不需要该属性"></el-input>
        </el-form-item>
        <el-form-item label="更新时间列名">
          <el-input v-model="updateTimeColumnName1" placeholder="请填写数据更新时间列名，系统将创建该属性，当更新数据时自动填充值。如果为空，则代表不需要该属性"></el-input>
        </el-form-item>
        <el-form-item label="更新者列名">
          <el-input v-model="updatorColumnName1" placeholder="请填写数据更新者列名，系统将创建该属性，当更新数据时自动填充值。如果为空，则代表不需要该属性"></el-input>
        </el-form-item>
      </template>
      <template v-if="mode === '2'">
        <el-form-item label="关联表">
          <el-select v-model="tableName2" @change="onTableChange" placeholder="请选择表" style="width:100%" filterable>
            <el-option v-for="table in tables" :key="table.name" :label="table.name + (table.cmt ? ('(' + table.cmt + ')') : '')" :value="table.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="ID列名">
          <el-input v-model="idColumnName2" placeholder="请填写表的ID列名"></el-input>
        </el-form-item>
        <el-form-item label="账户列名">
          <el-input v-model="accountColumnName2" placeholder="请填写表的账户列名，如果为空，代表该表的数据跟用户无从属关系；这里的用户仅指普通用户，非管理员"></el-input>
        </el-form-item>
        <el-form-item label="创建时间列名">
          <el-input v-model="createTimeColumnName2" placeholder="请填写数据创建时间列名，系统将创建该属性，当创建数据时自动填充值。如果为空，则代表不需要该属性"></el-input>
        </el-form-item>
        <el-form-item label="创建者列名">
          <el-input v-model="creatorColumnName2" placeholder="请填写数据创建者列名，系统将创建该属性，当创建数据时自动填充值。如果为空，则代表不需要该属性"></el-input>
        </el-form-item>
        <el-form-item label="更新时间列名">
          <el-input v-model="updateTimeColumnName2" placeholder="请填写数据更新时间列名，系统将创建该属性，当更新数据时自动填充值。如果为空，则代表不需要该属性"></el-input>
        </el-form-item>
        <el-form-item label="更新者列名">
          <el-input v-model="updatorColumnName2" placeholder="请填写数据更新者列名，系统将创建该属性，当更新数据时自动填充值。如果为空，则代表不需要该属性"></el-input>
        </el-form-item>
      </template>
    </el-form>

    <el-table :data="columns" :stripe="true" size="mini" v-if="mode === '2'" style="border:1px solid #ebeef5;margin-top:20px;">
      <el-table-column prop="cmt" label="注释"></el-table-column>
      <el-table-column prop="name" label="列名" width="180px"></el-table-column>
      <el-table-column prop="dataType" label="数据库类型" width="180px"></el-table-column>
      <el-table-column prop="nullable" label="可否为空" width="80px">
        <template slot-scope="scope">
          <span v-if="scope.row.nullable">可以</span>
          <span v-else>不可</span>
        </template>
      </el-table-column>
    </el-table>

    <div slot="footer">
      <el-button size="mini" @click="show = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="doSave">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'form-table-config-dialog',
  data () {
    return {
      mode: null,
      idColumnName1: null,
      accountColumnName1: null,
      createTimeColumnName1: null,
      updateTimeColumnName1: null,
      creatorColumnName1: null,
      updatorColumnName1: null,
      tableName2: null,
      idColumnName2: null,
      accountColumnName2: null,
      createTimeColumnName2: null,
      updateTimeColumnName2: null,
      creatorColumnName2: null,
      updatorColumnName2: null,
      tables: [],
      columns: [],
      show: false
    }
  },
  methods: {
    open (dynamicForm) {
      this.idColumnName1 = 'dynamic_form_data_id'
      this.accountColumnName1 = ''
      this.createTimeColumnName1 = ''
      this.createTimeColumnName1 = ''
      this.creatorColumnName1 = ''
      this.updatorColumnName1 = ''
      this.tableName2 = null
      this.idColumnName2 = null
      this.accountColumnName2 = null
      this.createTimeColumnName2 = ''
      this.createTimeColumnName2 = ''
      this.creatorColumnName2 = ''
      this.updatorColumnName2 = ''

      if (dynamicForm) {
        let tableName = dynamicForm.tableName
        if (tableName) {
          if (tableName.startsWith('df_')) {
            this.mode = '1'
            this.idColumnName1 = dynamicForm.idColumnName
            this.accountColumnName1 = dynamicForm.accountColumnName
            this.createTimeColumnName1 = dynamicForm.createTimeColumnName
            this.updateTimeColumnName1 = dynamicForm.updateTimeColumnName
            this.creatorColumnName1 = dynamicForm.creatorColumnName
            this.updatorColumnName1 = dynamicForm.updatorColumnName
          } else  {
            this.mode = '2'
            this.tableName2 = tableName
            this.idColumnName2 = dynamicForm.idColumnName
            this.accountColumnName2 = dynamicForm.accountColumnName
            this.createTimeColumnName2 = dynamicForm.createTimeColumnName
            this.updateTimeColumnName2 = dynamicForm.updateTimeColumnName
            this.creatorColumnName2 = dynamicForm.creatorColumnName
            this.updatorColumnName2 = dynamicForm.updatorColumnName
          }
        } else {
          this.mode = '3'
        }
      } else {
        this.mode = '1'
      }
      this.tables = []
      this.columns = []
      this.show = true
      this.loadMetadata()
    },
    loadMetadata () {
      if (this.mode === '2' && !this.tables.length) {
        this.$http.request({
          method: 'get',
          url: '/api/cgRdbDataSources/0/metadata'
        }).then((res) => {
          this.tables = res.data.data
          this.onTableChange(this.tableName2)
        })
      }
    },
    onTableChange (tableName) {
      let columns = []
      if (tableName) {
        for (let table of this.tables) {
          if (table.name === tableName) {
            columns = table.metaColumns
            break
          }
        }
      }
      this.columns = columns
    },
    doSave () {
      let data = {}
      if (this.mode === '1') {
        data.tableName = 'df_'
        data.idColumnName = this.idColumnName1
        data.accountColumnName = this.accountColumnName1
        data.createTimeColumnName = this.createTimeColumnName1
        data.updateTimeColumnName = this.updateTimeColumnName1
        data.creatorColumnName = this.creatorColumnName1
        data.updatorColumnName = this.updatorColumnName1
      } else if (this.mode === '2') {
        if (!this.tableName2) {
          alert('请选择关联表')
          return
        }
        if (!this.idColumnName2) {
          alert('请填写表的ID列名')
          return
        }
        data.tableName = this.tableName2
        data.idColumnName = this.idColumnName2
        data.accountColumnName = this.accountColumnName2
        data.createTimeColumnName = this.createTimeColumnName2
        data.updateTimeColumnName = this.updateTimeColumnName2
        data.creatorColumnName = this.creatorColumnName2
        data.updatorColumnName = this.updatorColumnName2
        data.columns = this.columns
      } else {
        data.createCreateTime = ''
        data.createUpdateTime = ''
        data.createCreator = ''
        data.createUpdator = ''
      }

      this.show = false
      this.$emit('save', data)
    }
  }
}
</script>
